export default __webpack_public_path__ + "static/5-402e238c53440146e3f47e89631f3ec7.png";